import debounce from './debounce';

const mobileDeviceCheck = (widthCallback, deviceCallback) => {
  let isMobileDevice = false;
  let isMobileWidth = false;
  let screenWidth = window.innerWidth;

  const conditions = [
    () => window.innerWidth < 768,
    () => window.devicePixelRatio > 1.5,
    () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    () => ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0),
  ];

  const checkMobile = () => conditions.filter(condition => condition()).length >= 2;
  const checkMobileWidth = () => window.innerWidth < 768;

  const handleResize = () => {
    const wasMobileDevice = isMobileDevice;
    const wasMobileWidth = isMobileWidth;

    isMobileDevice = checkMobile();
    isMobileWidth = checkMobileWidth();
    screenWidth = window.innerWidth;

    if (wasMobileWidth !== isMobileWidth) {
      widthCallback(isMobileWidth);
    }

    if (wasMobileDevice !== isMobileDevice) {
      deviceCallback(isMobileDevice);
    }
  };

  const debouncedResize = debounce(handleResize, 100);

  // Initial check
  handleResize();

  // Add event listeners
  window.addEventListener('resize', debouncedResize);
  screen.orientation.addEventListener('change', handleResize);

  // Return a method to remove event listeners if needed
  return () => {
    window.removeEventListener('resize', debouncedResize);
    screen.orientation.removeEventListener('change', handleResize);
  };
};

export default mobileDeviceCheck;